import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { IAddon } from "@bca-shared/models/addon";

@Component({
  selector: "bca-product-service",
  templateUrl: "product-service.component.html",
  styleUrls: ["product-service.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductServiceComponent {
  @Input()
  service: IAddon;
  @Output()
  selected = new EventEmitter<boolean>();

  toggleSelection(event) {
    const value = event.detail.checked;
    this.selected.emit(value);
  }

  getIconName(serviceUrl?: string): string {
    if (!serviceUrl) {
      return '';
    }
    const service = serviceUrl.substring(0, serviceUrl.length - 4);
    switch (service) {
      case 'taxi':
        return 'taxi';
      case 'carshare':
        return 'car-share';
      case 'internationaal':
        return 'suitcase';
      case 'bikeShed':
        return 'bikeShed';
      case 'parking':
        return 'park-ride';
      case 'scooterShare':
        return 'scooterShare';
      case 'bikeElectric':
        return 'bikeElectric';
      case 'bikeShare':
        return 'bikeShare';
      default:
        return 'accessibility';
    }
  }
  
}
